import { render, staticRenderFns } from "./Accounts.vue?vue&type=template&id=aef21c02&scoped=true&"
import script from "./Accounts.vue?vue&type=script&lang=js&"
export * from "./Accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef21c02",
  null
  
)

export default component.exports